// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const RoleIdTable: MarkdocTagRegistration = {
  tag: 'role-id-table',
  children: [],
  component: 'RoleIdTable',
  description: 'Table containing roles for the merchant',
  attributes: {
    roles: {
      type: Array,
      required: true,
      description: 'List of custom roles for the merchant',
    },
  },
};
